import SetupAccountForm from "components/SetupAccount/SetupAccountForm"
import { Container, Row } from "react-bootstrap"

const SetupAccount = () => {
    return (
        <>
            <Container>
                <Row>
                    <SetupAccountForm />
                </Row>
            </Container>
        </>
    )
}

export default SetupAccount